// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as Window$OrcaPaymentPage from "../Window.bs.js";
import * as APIUtils$OrcaPaymentPage from "./APIHelpers/APIUtils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as Constants$OrcaPaymentPage from "./Constants.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./ApiEndpoint.bs.js";
import * as BrowserSpec$OrcaPaymentPage from "../BrowserSpec.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./PaymentBody.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./RecoilAtoms.bs.js";
import * as PaymentError$OrcaPaymentPage from "../Types/PaymentError.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as PaymentConfirmTypes$OrcaPaymentPage from "../Types/PaymentConfirmTypes.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function getPaymentType(paymentMethodType) {
  switch (paymentMethodType) {
    case "apple_pay" :
        return "Applepay";
    case "" :
    case "credit" :
    case "debit" :
        return "Card";
    case "google_pay" :
        return "Gpay";
    case "paze" :
        return "Paze";
    case "samsung_pay" :
        return "Samsungpay";
    default:
      return "Other";
  }
}

function closePaymentLoaderIfAny() {
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "fullscreen",
          false
        ]]);
}

async function retrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSyncOpt, sdkAuthorizationOpt) {
  var isForceSync = isForceSyncOpt !== undefined ? isForceSyncOpt : false;
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: publishableKey,
        clientSecret: clientSecret,
        forceSync: isForceSync ? "true" : undefined,
        sdkAuthorization: sdkAuthorization
      }, "RetrievePaymentIntent");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  var headers$1 = headers !== undefined ? headers : ({});
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "RETRIEVE_CALL", logger, onSuccess, onFailure, undefined, headers$1, "GET", Caml_option.some(customPodUri), Caml_option.some(publishableKey), undefined, undefined, Caml_option.some(sdkAuthorization), undefined);
}

async function fetchPaymentMethodEligibility(clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorizationOpt, endpoint, signal) {
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: publishableKey,
        customBackendBaseUrl: endpoint,
        clientSecret: clientSecret,
        sdkAuthorization: sdkAuthorization
      }, "FetchPaymentMethodEligibility");
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  var body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
                "client_secret",
                clientSecret
              ]]));
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "PAYMENT_METHOD_ELIGIBILITY_CALL", logger, onSuccess, onFailure, JSON.stringify(body), undefined, "POST", Caml_option.some(customPodUri), Caml_option.some(publishableKey), undefined, undefined, Caml_option.some(sdkAuthorization), signal);
}

async function threeDsAuth(clientSecret, logger, threeDsMethodComp, headers, sdkAuthorizationOpt) {
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var url = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        clientSecret: clientSecret,
        sdkAuthorization: sdkAuthorization
      }, "FetchThreeDsAuth");
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  var clientSecretArr = match !== undefined ? [] : [[
        "client_secret",
        clientSecret
      ]];
  var body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
          [
            "device_channel",
            "BRW"
          ],
          [
            "threeds_method_comp_ind",
            threeDsMethodComp
          ]
        ].concat(BrowserSpec$OrcaPaymentPage.broswerInfo(), clientSecretArr));
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (data) {
    var dict = Utils$OrcaPaymentPage.getDictFromJson(data);
    var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
    closePaymentLoaderIfAny();
    Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
    return null;
  };
  var onCatchCallback = function (err) {
    closePaymentLoaderIfAny();
    return Js_exn.raiseError(JSON.stringify(err));
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(url, "AUTHENTICATION_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", undefined, undefined, undefined, Caml_option.some(onCatchCallback), Caml_option.some(sdkAuthorization), undefined);
}

function pollRetrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSyncOpt, sdkAuthorizationOpt) {
  var isForceSync = isForceSyncOpt !== undefined ? isForceSyncOpt : false;
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  return Core__Promise.$$catch(retrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSync, Caml_option.some(sdkAuthorization)).then(function (json) {
                  var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
                  var status = Utils$OrcaPaymentPage.getString(dict, "status", "");
                  if (status === "succeeded" || status === "failed") {
                    return Promise.resolve(json);
                  } else {
                    return Core__Promise.$$catch(Utils$OrcaPaymentPage.delay(2000).then(function (_val) {
                                    return pollRetrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSync, Caml_option.some(sdkAuthorization));
                                  }), (function (param) {
                                  return Promise.resolve(null);
                                }));
                  }
                }), (function (e) {
                console.error("Unable to retrieve payment due to following error", e);
                return pollRetrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSync, Caml_option.some(sdkAuthorization));
              }));
}

async function retrieveStatus(publishableKey, customPodUri, pollID, logger, sdkAuthorization) {
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: publishableKey,
        pollId: pollID,
        sdkAuthorization: sdkAuthorization
      }, "RetrieveStatus");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "POLL_STATUS_CALL", logger, onSuccess, onFailure, "", undefined, "GET", Caml_option.some(customPodUri), Caml_option.some(publishableKey), undefined, undefined, Caml_option.some(sdkAuthorization), undefined);
}

function pollStatus(publishableKey, customPodUri, pollId, interval, count, returnUrl, logger, sdkAuthorization) {
  return Core__Promise.$$catch(retrieveStatus(publishableKey, customPodUri, pollId, logger, sdkAuthorization).then(function (json) {
                  var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
                  var status = Utils$OrcaPaymentPage.getString(dict, "status", "");
                  return new Promise((function (resolve, param) {
                                if (status === "completed") {
                                  return resolve(json);
                                } else if (count === 0) {
                                  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                                          "fullscreen",
                                          false
                                        ]]);
                                  return Utils$OrcaPaymentPage.openUrl(returnUrl);
                                } else {
                                  Core__Promise.$$catch(Utils$OrcaPaymentPage.delay(interval).then(function (param) {
                                            return pollStatus(publishableKey, customPodUri, pollId, interval, count - 1 | 0, returnUrl, logger, sdkAuthorization).then(function (res) {
                                                        resolve(res);
                                                        return Promise.resolve();
                                                      });
                                          }), (function (param) {
                                          return Promise.resolve();
                                        }));
                                  return ;
                                }
                              }));
                }), (function (e) {
                console.error("Unable to retrieve payment due to following error", e);
                return pollStatus(publishableKey, customPodUri, pollId, interval, count - 1 | 0, returnUrl, logger, sdkAuthorization).then(function (res) {
                            return Promise.resolve(res);
                          });
              }));
}

function intentCall(fetchApi, uri, headers, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, fetchMethod, setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, counter, isPaymentSessionOpt, isCallbackUsedVal, componentNameOpt, redirectionFlags, sdkAuthorizationOpt, modeOpt) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var componentName = componentNameOpt !== undefined ? componentNameOpt : "payment";
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var mode = modeOpt !== undefined ? modeOpt : "NONE";
  var isConfirm = uri.includes("/confirm");
  var isCompleteAuthorize = uri.includes("/complete_authorize");
  var isPostSessionTokens = uri.includes("/post_session_tokens");
  var match = isConfirm ? [
      "CONFIRM_CALL",
      "CONFIRM_CALL_INIT"
    ] : (
      isCompleteAuthorize ? [
          "COMPLETE_AUTHORIZE_CALL",
          "COMPLETE_AUTHORIZE_CALL_INIT"
        ] : (
          isPostSessionTokens ? [
              "POST_SESSION_TOKENS_CALL",
              "POST_SESSION_TOKENS_CALL_INIT"
            ] : [
              "RETRIEVE_CALL",
              "RETRIEVE_CALL_INIT"
            ]
        )
    );
  var eventName = match[0];
  LoggerUtils$OrcaPaymentPage.logApi(match[1], undefined, undefined, "Request", uri, undefined, undefined, optLogger, "INFO", "API", isPaymentSession);
  var handleOpenUrl = function (url) {
    if (isPaymentSession && mode !== "CardCVCElement") {
      return Utils$OrcaPaymentPage.replaceRootHref(url, redirectionFlags);
    } else {
      return Utils$OrcaPaymentPage.openUrl(url);
    }
  };
  return Core__Promise.$$catch(fetchApi(uri, bodyStr, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), fetchMethod, undefined, undefined, Caml_option.some(sdkAuthorization), undefined).then(function (res) {
                  var statusCode = res.status;
                  var url = new URL(confirmParam.return_url);
                  url.searchParams.set("payment_intent_client_secret", clientSecret);
                  url.searchParams.set("status", "failed");
                  url.searchParams.set("payment_id", Utils$OrcaPaymentPage.getPaymentId(clientSecret));
                  Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                          "confirmParams",
                          confirmParam
                        ]]);
                  if (res.ok) {
                    return res.json().then(function (data) {
                                return new Promise((function (resolve, param) {
                                                LoggerUtils$OrcaPaymentPage.logApi(eventName, statusCode, undefined, "Response", uri, undefined, undefined, optLogger, undefined, undefined, isPaymentSession);
                                                var intent = PaymentConfirmTypes$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(data));
                                                var paymentMethod;
                                                paymentMethod = paymentType === "Card" ? "CARD" : intent.payment_method_type;
                                                var url = new URL(confirmParam.return_url);
                                                url.searchParams.set("payment_intent_client_secret", clientSecret);
                                                url.searchParams.set("payment_id", Utils$OrcaPaymentPage.getPaymentId(clientSecret));
                                                url.searchParams.set("status", intent.status);
                                                var handleProcessingStatus = function (paymentType, sdkHandleOneClickConfirmPayment) {
                                                  var exit = 0;
                                                  switch (paymentType) {
                                                    case "Card" :
                                                        exit = 2;
                                                        break;
                                                    case "Gpay" :
                                                    case "Applepay" :
                                                    case "Paypal" :
                                                        exit = sdkHandleOneClickConfirmPayment ? 1 : 2;
                                                        break;
                                                    default:
                                                      exit = 1;
                                                  }
                                                  switch (exit) {
                                                    case 1 :
                                                        if (mode === "CardCVCElement") {
                                                          return resolve(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                                                          [
                                                                            "data",
                                                                            data
                                                                          ],
                                                                          [
                                                                            "returnUrl",
                                                                            url.href
                                                                          ]
                                                                        ]));
                                                        } else if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                          closePaymentLoaderIfAny();
                                                          return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                        } else {
                                                          return handleOpenUrl(url.href);
                                                        }
                                                    case 2 :
                                                        if (isPaymentSession) {
                                                          if (confirmParam.redirect === "always") {
                                                            if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                              return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                            } else {
                                                              return handleOpenUrl(url.href);
                                                            }
                                                          } else {
                                                            return resolve(data);
                                                          }
                                                        } else {
                                                          if (Core__Option.getOr(isCallbackUsedVal, false)) {
                                                            Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                                                          } else {
                                                            closePaymentLoaderIfAny();
                                                          }
                                                          return Utils$OrcaPaymentPage.postSubmitResponse(data, url.href);
                                                        }
                                                    
                                                  }
                                                };
                                                var pollForPixQrCode = function (attempt) {
                                                  return Core__Promise.$$catch(retrievePaymentIntent(clientSecret, Object.fromEntries(headers), confirmParam.publishableKey, Core__Option.getOr(optLogger, LoggerUtils$OrcaPaymentPage.defaultLoggerConfig), customPodUri, true, Caml_option.some(sdkAuthorization)).then(function (json) {
                                                                  var polledIntent = PaymentConfirmTypes$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
                                                                  if (!(polledIntent.status === "requires_customer_action" && polledIntent.nextAction.type_ === "qr_code_information")) {
                                                                    if (polledIntent.status === "succeeded" || polledIntent.status === "failed" || attempt >= 20) {
                                                                      handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                                      resolve(json);
                                                                      return Promise.resolve();
                                                                    } else {
                                                                      return Utils$OrcaPaymentPage.delay(2000).then(function (param) {
                                                                                  return pollForPixQrCode(attempt + 1 | 0);
                                                                                });
                                                                    }
                                                                  }
                                                                  var qrData = Core__Option.getOr(polledIntent.nextAction.image_data_url, "");
                                                                  var rawQrData = Core__Option.getOr(polledIntent.nextAction.raw_qr_data, "");
                                                                  var displayText = Core__Option.getOr(polledIntent.nextAction.display_text, "");
                                                                  var borderColor = Core__Option.getOr(polledIntent.nextAction.border_color, "");
                                                                  var expiryTime = Core__Option.getOr(polledIntent.nextAction.display_to_timestamp, 0.0);
                                                                  var headerObj = {};
                                                                  Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj, headers);
                                                                  var metaData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                                                        [
                                                                          "qrData",
                                                                          qrData
                                                                        ],
                                                                        [
                                                                          "rawQrData",
                                                                          rawQrData
                                                                        ],
                                                                        [
                                                                          "paymentIntentId",
                                                                          clientSecret
                                                                        ],
                                                                        [
                                                                          "sdkAuthorization",
                                                                          Core__Option.getOr(sdkAuthorization, "")
                                                                        ],
                                                                        [
                                                                          "publishableKey",
                                                                          confirmParam.publishableKey
                                                                        ],
                                                                        [
                                                                          "headers",
                                                                          headerObj
                                                                        ],
                                                                        [
                                                                          "expiryTime",
                                                                          expiryTime.toString()
                                                                        ],
                                                                        [
                                                                          "url",
                                                                          url.href
                                                                        ],
                                                                        [
                                                                          "paymentMethod",
                                                                          paymentMethod
                                                                        ],
                                                                        [
                                                                          "display_text",
                                                                          displayText
                                                                        ],
                                                                        [
                                                                          "border_color",
                                                                          borderColor
                                                                        ]
                                                                      ]);
                                                                  if (!isPaymentSession) {
                                                                    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                                          [
                                                                            "fullscreen",
                                                                            true
                                                                          ],
                                                                          [
                                                                            "param",
                                                                            "qrData"
                                                                          ],
                                                                          [
                                                                            "iframeId",
                                                                            iframeId
                                                                          ],
                                                                          [
                                                                            "metadata",
                                                                            metaData
                                                                          ]
                                                                        ]);
                                                                  }
                                                                  resolve(json);
                                                                  return Promise.resolve();
                                                                }), (function (param) {
                                                                handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                                resolve(data);
                                                                return Promise.resolve();
                                                              }));
                                                };
                                                if (intent.status === "requires_customer_action") {
                                                  if (intent.nextAction.type_ === "redirect_to_url") {
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "REDIRECTING_USER", paymentMethod, undefined);
                                                    return handleOpenUrl(intent.nextAction.redirectToUrl);
                                                  }
                                                  if (intent.nextAction.type_ === "redirect_inside_popup") {
                                                    var popupUrl = intent.nextAction.popupUrl;
                                                    var redirectResponseUrl = intent.nextAction.redirectResponseUrl;
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "THREE_DS_POPUP_REDIRECTION", paymentMethod, undefined);
                                                    var metaData = [
                                                      [
                                                        "popupUrl",
                                                        popupUrl
                                                      ],
                                                      [
                                                        "redirectResponseUrl",
                                                        redirectResponseUrl
                                                      ]
                                                    ];
                                                    return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                                [
                                                                  "fullscreen",
                                                                  true
                                                                ],
                                                                [
                                                                  "param",
                                                                  "3dsRedirectionPopup"
                                                                ],
                                                                [
                                                                  "iframeId",
                                                                  iframeId
                                                                ],
                                                                [
                                                                  "metadata",
                                                                  Utils$OrcaPaymentPage.getJsonFromArrayOfJson(metaData)
                                                                ]
                                                              ]);
                                                  }
                                                  if (intent.nextAction.type_ === "display_bank_transfer_information") {
                                                    var obj = intent.nextAction.bank_transfer_steps_and_charges_details;
                                                    var metadata = obj !== undefined ? Utils$OrcaPaymentPage.getDictFromJson(obj) : ({});
                                                    var dict = Utils$OrcaPaymentPage.deepCopyDict(metadata);
                                                    dict["data"] = data;
                                                    dict["url"] = url.href;
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "DISPLAY_BANK_TRANSFER_INFO_PAGE", paymentMethod, undefined);
                                                    if (!isPaymentSession) {
                                                      Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                            [
                                                              "fullscreen",
                                                              true
                                                            ],
                                                            [
                                                              "param",
                                                              intent.payment_method_type + "BankTransfer"
                                                            ],
                                                            [
                                                              "iframeId",
                                                              iframeId
                                                            ],
                                                            [
                                                              "metadata",
                                                              dict
                                                            ]
                                                          ]);
                                                    }
                                                    return resolve(data);
                                                  }
                                                  if (intent.nextAction.type_ === "qr_code_information") {
                                                    var qrData = Core__Option.getOr(intent.nextAction.image_data_url, "");
                                                    var rawQrData = Core__Option.getOr(intent.nextAction.raw_qr_data, "");
                                                    var displayText = Core__Option.getOr(intent.nextAction.display_text, "");
                                                    var borderColor = Core__Option.getOr(intent.nextAction.border_color, "");
                                                    var expiryTime = Core__Option.getOr(intent.nextAction.display_to_timestamp, 0.0);
                                                    var headerObj = {};
                                                    Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj, headers);
                                                    var metaData$1 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                                          [
                                                            "qrData",
                                                            qrData
                                                          ],
                                                          [
                                                            "rawQrData",
                                                            rawQrData
                                                          ],
                                                          [
                                                            "paymentIntentId",
                                                            clientSecret
                                                          ],
                                                          [
                                                            "sdkAuthorization",
                                                            Core__Option.getOr(sdkAuthorization, "")
                                                          ],
                                                          [
                                                            "publishableKey",
                                                            confirmParam.publishableKey
                                                          ],
                                                          [
                                                            "headers",
                                                            headerObj
                                                          ],
                                                          [
                                                            "expiryTime",
                                                            expiryTime.toString()
                                                          ],
                                                          [
                                                            "url",
                                                            url.href
                                                          ],
                                                          [
                                                            "paymentMethod",
                                                            paymentMethod
                                                          ],
                                                          [
                                                            "display_text",
                                                            displayText
                                                          ],
                                                          [
                                                            "border_color",
                                                            borderColor
                                                          ]
                                                        ]);
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "DISPLAY_QR_CODE_INFO_PAGE", paymentMethod, undefined);
                                                    if (!isPaymentSession) {
                                                      Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                            [
                                                              "fullscreen",
                                                              true
                                                            ],
                                                            [
                                                              "param",
                                                              "qrData"
                                                            ],
                                                            [
                                                              "iframeId",
                                                              iframeId
                                                            ],
                                                            [
                                                              "metadata",
                                                              metaData$1
                                                            ]
                                                          ]);
                                                    }
                                                    return resolve(data);
                                                  }
                                                  if (intent.nextAction.type_ === "three_ds_invoke") {
                                                    var threeDsData = Core__Option.getOr(Core__Option.flatMap(intent.nextAction.three_ds_data, Core__JSON.Decode.object), {});
                                                    var do3dsMethodCall = Utils$OrcaPaymentPage.getBoolValue(Core__JSON.Decode.bool(Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(threeDsData["three_ds_method_details"], Core__JSON.Decode.object), (function (x) {
                                                                        return x["three_ds_method_data_submission"];
                                                                      })), {})));
                                                    var headerObj$1 = {};
                                                    Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj$1, headers);
                                                    var metaData$2 = Object.fromEntries([
                                                          [
                                                            "threeDSData",
                                                            threeDsData
                                                          ],
                                                          [
                                                            "paymentIntentId",
                                                            clientSecret
                                                          ],
                                                          [
                                                            "publishableKey",
                                                            confirmParam.publishableKey
                                                          ],
                                                          [
                                                            "sdkAuthorization",
                                                            Core__Option.getOr(sdkAuthorization, "")
                                                          ],
                                                          [
                                                            "headers",
                                                            headerObj$1
                                                          ],
                                                          [
                                                            "url",
                                                            url.href
                                                          ],
                                                          [
                                                            "iframeId",
                                                            iframeId
                                                          ]
                                                        ]);
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, do3dsMethodCall ? "Y" : "N", "THREE_DS_METHOD", paymentMethod, undefined);
                                                    if (do3dsMethodCall) {
                                                      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                                  [
                                                                    "fullscreen",
                                                                    true
                                                                  ],
                                                                  [
                                                                    "param",
                                                                    "3ds"
                                                                  ],
                                                                  [
                                                                    "iframeId",
                                                                    iframeId
                                                                  ],
                                                                  [
                                                                    "metadata",
                                                                    metaData$2
                                                                  ]
                                                                ]);
                                                    } else {
                                                      metaData$2["3dsMethodComp"] = "U";
                                                      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                                  [
                                                                    "fullscreen",
                                                                    true
                                                                  ],
                                                                  [
                                                                    "param",
                                                                    "3dsAuth"
                                                                  ],
                                                                  [
                                                                    "iframeId",
                                                                    iframeId
                                                                  ],
                                                                  [
                                                                    "metadata",
                                                                    metaData$2
                                                                  ]
                                                                ]);
                                                    }
                                                  }
                                                  if (intent.nextAction.type_ === "invoke_hidden_iframe") {
                                                    var iframeData = Core__Option.getOr(Core__Option.flatMap(intent.nextAction.iframe_data, Core__JSON.Decode.object), {});
                                                    var headerObj$2 = {};
                                                    Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj$2, headers);
                                                    var metaData$3 = Object.fromEntries([
                                                          [
                                                            "iframeData",
                                                            iframeData
                                                          ],
                                                          [
                                                            "clientSecret",
                                                            clientSecret
                                                          ],
                                                          [
                                                            "publishableKey",
                                                            confirmParam.publishableKey
                                                          ],
                                                          [
                                                            "sdkAuthorization",
                                                            Core__Option.getOr(sdkAuthorization, "")
                                                          ],
                                                          [
                                                            "headers",
                                                            headerObj$2
                                                          ],
                                                          [
                                                            "url",
                                                            url.href
                                                          ],
                                                          [
                                                            "iframeId",
                                                            iframeId
                                                          ],
                                                          [
                                                            "confirmParams",
                                                            confirmParam
                                                          ]
                                                        ]);
                                                    return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                                [
                                                                  "fullscreen",
                                                                  true
                                                                ],
                                                                [
                                                                  "param",
                                                                  "redsys3ds"
                                                                ],
                                                                [
                                                                  "iframeId",
                                                                  iframeId
                                                                ],
                                                                [
                                                                  "metadata",
                                                                  metaData$3
                                                                ]
                                                              ]);
                                                  }
                                                  if (intent.nextAction.type_ === "display_voucher_information") {
                                                    var voucherData = Core__Option.getOr(intent.nextAction.voucher_details, {
                                                          download_url: "",
                                                          reference: ""
                                                        });
                                                    var headerObj$3 = {};
                                                    Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj$3, headers);
                                                    var metaData$4 = Object.fromEntries([
                                                          [
                                                            "voucherUrl",
                                                            voucherData.download_url
                                                          ],
                                                          [
                                                            "reference",
                                                            voucherData.reference
                                                          ],
                                                          [
                                                            "returnUrl",
                                                            url.href
                                                          ],
                                                          [
                                                            "paymentMethod",
                                                            paymentMethod
                                                          ],
                                                          [
                                                            "payment_intent_data",
                                                            data
                                                          ]
                                                        ]);
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "DISPLAY_VOUCHER", paymentMethod, undefined);
                                                    return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                                                                [
                                                                  "fullscreen",
                                                                  true
                                                                ],
                                                                [
                                                                  "param",
                                                                  "voucherData"
                                                                ],
                                                                [
                                                                  "iframeId",
                                                                  iframeId
                                                                ],
                                                                [
                                                                  "metadata",
                                                                  metaData$4
                                                                ]
                                                              ]);
                                                  }
                                                  if (intent.nextAction.type_ === "third_party_sdk_session_token") {
                                                    var token = intent.nextAction.session_token;
                                                    var session_token = token !== undefined ? Utils$OrcaPaymentPage.getDictFromJson(token) : ({});
                                                    var walletName = Utils$OrcaPaymentPage.getString(session_token, "wallet_name", "");
                                                    var message;
                                                    switch (walletName) {
                                                      case "apple_pay" :
                                                          message = [
                                                            [
                                                              "applePayButtonClicked",
                                                              true
                                                            ],
                                                            [
                                                              "applePayPresent",
                                                              session_token
                                                            ],
                                                            [
                                                              "componentName",
                                                              componentName
                                                            ]
                                                          ];
                                                          break;
                                                      case "google_pay" :
                                                          message = [[
                                                              "googlePayThirdPartyFlow",
                                                              session_token
                                                            ]];
                                                          break;
                                                      case "open_banking" :
                                                          var metaData$5 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                                                [
                                                                  "linkToken",
                                                                  Utils$OrcaPaymentPage.getString(session_token, "open_banking_session_token", "")
                                                                ],
                                                                [
                                                                  "pmAuthConnectorArray",
                                                                  ["plaid"]
                                                                ],
                                                                [
                                                                  "publishableKey",
                                                                  confirmParam.publishableKey
                                                                ],
                                                                [
                                                                  "clientSecret",
                                                                  clientSecret
                                                                ],
                                                                [
                                                                  "sdkAuthorization",
                                                                  Core__Option.getOr(sdkAuthorization, "")
                                                                ],
                                                                [
                                                                  "isForceSync",
                                                                  true
                                                                ]
                                                              ]);
                                                          message = [
                                                            [
                                                              "fullscreen",
                                                              true
                                                            ],
                                                            [
                                                              "param",
                                                              "plaidSDK"
                                                            ],
                                                            [
                                                              "iframeId",
                                                              iframeId
                                                            ],
                                                            [
                                                              "metadata",
                                                              metaData$5
                                                            ]
                                                          ];
                                                          break;
                                                      default:
                                                        message = [];
                                                    }
                                                    if (!isPaymentSession) {
                                                      Utils$OrcaPaymentPage.messageParentWindow(undefined, message);
                                                    }
                                                    return resolve(data);
                                                  }
                                                  if (intent.nextAction.type_ === "invoke_sdk_client") {
                                                    var nextActionData = Core__Option.getOr(intent.nextAction.next_action_data, null);
                                                    var response = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                                          [
                                                            "orderId",
                                                            intent.connectorTransactionId
                                                          ],
                                                          [
                                                            "nextActionData",
                                                            nextActionData
                                                          ]
                                                        ]);
                                                    return resolve(response);
                                                  }
                                                  if (!isPaymentSession) {
                                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                  }
                                                  if (uri.includes("force_sync=true")) {
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.nextAction.type_, "REDIRECTING_USER", paymentMethod, "ERROR");
                                                    return handleOpenUrl(url.href);
                                                  }
                                                  var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                  return resolve(failedSubmitResponse);
                                                }
                                                if (intent.status === "requires_payment_method") {
                                                  if (intent.nextAction.type_ !== "invoke_sdk_client") {
                                                    return ;
                                                  }
                                                  var nextActionData$1 = Core__Option.getOr(intent.nextAction.next_action_data, null);
                                                  var response$1 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                                                        [
                                                          "orderId",
                                                          intent.connectorTransactionId
                                                        ],
                                                        [
                                                          "nextActionData",
                                                          nextActionData$1
                                                        ]
                                                      ]);
                                                  return resolve(response$1);
                                                }
                                                if (intent.status === "processing") {
                                                  if (intent.nextAction.type_ !== "third_party_sdk_session_token") {
                                                    if (intent.payment_method_type === "pix") {
                                                      pollForPixQrCode(0);
                                                      return ;
                                                    } else {
                                                      handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                      return resolve(data);
                                                    }
                                                  }
                                                  var token$1 = intent.nextAction.session_token;
                                                  var session_token$1 = token$1 !== undefined ? Utils$OrcaPaymentPage.getDictFromJson(token$1) : ({});
                                                  var walletName$1 = Utils$OrcaPaymentPage.getString(session_token$1, "wallet_name", "");
                                                  var message$1;
                                                  switch (walletName$1) {
                                                    case "apple_pay" :
                                                        message$1 = [
                                                          [
                                                            "applePayButtonClicked",
                                                            true
                                                          ],
                                                          [
                                                            "applePayPresent",
                                                            session_token$1
                                                          ]
                                                        ];
                                                        break;
                                                    case "google_pay" :
                                                        message$1 = [[
                                                            "googlePayThirdPartyFlow",
                                                            session_token$1
                                                          ]];
                                                        break;
                                                    default:
                                                      message$1 = [];
                                                  }
                                                  if (!isPaymentSession) {
                                                    Utils$OrcaPaymentPage.messageParentWindow(undefined, message$1);
                                                  }
                                                  return resolve(data);
                                                }
                                                if (intent.status !== "") {
                                                  if (intent.status === "succeeded") {
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.status, "PAYMENT_SUCCESS", paymentMethod, undefined);
                                                  } else if (intent.status === "failed") {
                                                    LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.status, "PAYMENT_FAILED", paymentMethod, undefined);
                                                  }
                                                  if (intent.status === "failed") {
                                                    setIsManualRetryEnabled(function (param) {
                                                          return intent.manualRetryAllowed;
                                                        });
                                                  }
                                                  return handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
                                                }
                                                if (!isPaymentSession) {
                                                  return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                }
                                                var failedSubmitResponse$1 = Utils$OrcaPaymentPage.getFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
                                                resolve(failedSubmitResponse$1);
                                              })).then(function (prim) {
                                            return Promise.resolve(prim);
                                          });
                              });
                  } else {
                    return Core__Promise.$$catch(res.json().then(function (data) {
                                    return new Promise((function (resolve, param) {
                                                    if (isConfirm) {
                                                      var paymentMethod;
                                                      paymentMethod = paymentType === "Card" ? "CARD" : Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(bodyStr)), "payment_method_type", "");
                                                      LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, JSON.stringify(data), "PAYMENT_FAILED", paymentMethod, undefined);
                                                    }
                                                    LoggerUtils$OrcaPaymentPage.logApi(eventName, statusCode, data, "Err", uri, undefined, undefined, optLogger, "ERROR", "API", isPaymentSession);
                                                    var dict = Utils$OrcaPaymentPage.getDictFromJson(data);
                                                    var errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
                                                    if (!isPaymentSession) {
                                                      closePaymentLoaderIfAny();
                                                      Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                                    }
                                                    if (handleUserError) {
                                                      return handleOpenUrl(url.href);
                                                    }
                                                    var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
                                                    resolve(failedSubmitResponse);
                                                  })).then(function (prim) {
                                                return Promise.resolve(prim);
                                              });
                                  }), (function (err) {
                                  return new Promise((function (resolve, param) {
                                                  var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                                                  LoggerUtils$OrcaPaymentPage.logApi(eventName, statusCode, exceptionMessage, "NoResponse", uri, undefined, undefined, optLogger, "ERROR", "API", isPaymentSession);
                                                  if (counter >= 5) {
                                                    if (!isPaymentSession) {
                                                      closePaymentLoaderIfAny();
                                                      Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                                                    }
                                                    if (handleUserError) {
                                                      return handleOpenUrl(url.href);
                                                    }
                                                    var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                                    return resolve(failedSubmitResponse);
                                                  }
                                                  var paymentIntentID = Utils$OrcaPaymentPage.getPaymentId(clientSecret);
                                                  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isConfirm);
                                                  var retrieveUri = endpoint + "/payments/" + paymentIntentID + "?client_secret=" + clientSecret;
                                                  Core__Promise.$$catch(intentCall(fetchApi, retrieveUri, headers, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "GET", setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, counter + 1 | 0, undefined, undefined, componentName, redirectionFlags, Caml_option.some(sdkAuthorization), undefined).then(function (res) {
                                                            resolve(res);
                                                            return Promise.resolve();
                                                          }), (function (param) {
                                                          return Promise.resolve();
                                                        }));
                                                })).then(function (prim) {
                                              return Promise.resolve(prim);
                                            });
                                }));
                  }
                }), (function (err) {
                return new Promise((function (resolve, param) {
                                try {
                                  var url = new URL(confirmParam.return_url);
                                  url.searchParams.set("payment_intent_client_secret", clientSecret);
                                  url.searchParams.set("payment_id", Utils$OrcaPaymentPage.getPaymentId(clientSecret));
                                  url.searchParams.set("status", "failed");
                                  var exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
                                  LoggerUtils$OrcaPaymentPage.logApi(eventName, undefined, exceptionMessage, "NoResponse", uri, undefined, undefined, optLogger, "ERROR", "API", isPaymentSession);
                                  if (counter >= 5) {
                                    if (!isPaymentSession) {
                                      closePaymentLoaderIfAny();
                                      Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                                    }
                                    if (handleUserError) {
                                      return handleOpenUrl(url.href);
                                    }
                                    var failedSubmitResponse = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                    return resolve(failedSubmitResponse);
                                  }
                                  var paymentIntentID = Utils$OrcaPaymentPage.getPaymentId(clientSecret);
                                  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isConfirm);
                                  var retrieveUri = endpoint + "/payments/" + paymentIntentID + "?client_secret=" + clientSecret;
                                  Core__Promise.$$catch(intentCall(fetchApi, retrieveUri, headers, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "GET", setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, counter + 1 | 0, isPaymentSession, undefined, componentName, redirectionFlags, Caml_option.some(sdkAuthorization), undefined).then(function (res) {
                                            resolve(res);
                                            return Promise.resolve();
                                          }), (function (param) {
                                          return Promise.resolve();
                                        }));
                                  return ;
                                }
                                catch (exn){
                                  if (!isPaymentSession) {
                                    Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong");
                                  }
                                  var failedSubmitResponse$1 = Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong");
                                  return resolve(failedSubmitResponse$1);
                                }
                              })).then(function (prim) {
                            return Promise.resolve(prim);
                          });
              }));
}

function usePaymentSync(optLogger, paymentType) {
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var isCallbackUsedVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  var setIsManualRetryEnabled = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  return function (handleUserErrorOpt, confirmParam, iframeIdOpt) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var iframeId = iframeIdOpt !== undefined ? iframeIdOpt : "";
    var clientSecret = keys.clientSecret;
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("sync_payment_failed", "Sync Payment Failed. Try Again!");
    }
    var paymentIntentID = Utils$OrcaPaymentPage.getPaymentId(clientSecret);
    var headers = [[
        "Content-Type",
        "application/json"
      ]];
    var match = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    if (match !== undefined) {
      
    } else {
      headers.push([
            "api-key",
            confirmParam.publishableKey
          ]);
    }
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    var match$1 = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    var clientSecretUriStr = match$1 !== undefined ? "" : "&client_secret=" + clientSecret;
    var uri = endpoint + "/payments/" + paymentIntentID + "?force_sync=true" + clientSecretUriStr;
    var paymentSync = function () {
      intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, "", confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "GET", setIsManualRetryEnabled, customPodUri, keys.sdkHandleOneClickConfirmPayment, 0, undefined, isCallbackUsedVal, undefined, redirectionFlags, Caml_option.some(keys.sdkAuthorization), undefined);
    };
    if (typeof paymentMethodList !== "object" || paymentMethodList.TAG !== "Loaded") {
      return ;
    } else {
      return paymentSync();
    }
  };
}

function maskStr(str) {
  return str.replace(/\S/g, "x");
}

function maskPayload(payloadJson) {
  var valueDict = Core__JSON.Classify.classify(payloadJson);
  if (typeof valueDict !== "object") {
    return "null";
  }
  switch (valueDict.TAG) {
    case "Bool" :
        return Utils$OrcaPaymentPage.getStringFromBool(valueDict._0);
    case "String" :
        return maskStr(valueDict._0);
    case "Number" :
        return maskStr(valueDict._0.toString());
    case "Object" :
        return Utils$OrcaPaymentPage.getJsonFromArrayOfJson(Object.entries(valueDict._0).map(function (entry) {
                        return [
                                entry[0],
                                maskPayload(entry[1])
                              ];
                      }));
    case "Array" :
        return valueDict._0.map(maskPayload);
    
  }
}

function useCompleteAuthorizeHandler() {
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var setIsManualRetryEnabled = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  var isCallbackUsedVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  return function (clientSecret, bodyArr, confirmParam, iframeId, optLogger, handleUserError, paymentType, sdkHandleOneClickConfirmPayment, headers, paymentMode, sdkAuthorization) {
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("complete_authorize_failed", "Complete Authorize Failed. Try Again!");
    }
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    var uri = endpoint + "/payments/" + Utils$OrcaPaymentPage.getPaymentId(clientSecret) + "/complete_authorize";
    var finalHeaders = headers !== undefined ? headers : [
        [
          "Content-Type",
          "application/json"
        ],
        [
          "X-Client-Source",
          Core__Option.getOr(paymentMode, "")
        ]
      ];
    var match = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    var match$1 = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
    var sdkAuth = match !== undefined ? match : (
        match$1 !== undefined ? match$1 : undefined
      );
    if (sdkAuth !== undefined) {
      finalHeaders.push([
            "Authorization",
            sdkAuth
          ]);
    } else {
      finalHeaders.push([
            "api-key",
            confirmParam.publishableKey
          ]);
    }
    var clientSecretArr = sdkAuth !== undefined ? [] : [[
          "client_secret",
          clientSecret
        ]];
    var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(clientSecretArr.concat(bodyArr, BrowserSpec$OrcaPaymentPage.broswerInfo())));
    intentCall(Utils$OrcaPaymentPage.fetchApi, uri, finalHeaders, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "POST", setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, 0, undefined, isCallbackUsedVal, undefined, redirectionFlags, Caml_option.some(sdkAuth), undefined);
  };
}

function useCompleteAuthorize(optLogger, paymentType) {
  var completeAuthorizeHandler = useCompleteAuthorizeHandler();
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var mode = CardThemeType$OrcaPaymentPage.getPaymentModeToStrMapper(CardThemeType$OrcaPaymentPage.getPaymentMode(CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName")));
  return function (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var iframeId = iframeIdOpt !== undefined ? iframeIdOpt : keys.iframeId;
    if (typeof paymentMethodList !== "object" || paymentMethodList.TAG !== "Loaded") {
      return ;
    } else {
      return completeAuthorizeHandler(keys.clientSecret, bodyArr, confirmParam, iframeId, optLogger, handleUserError, paymentType, keys.sdkHandleOneClickConfirmPayment, undefined, mode, undefined);
    }
  };
}

function useRedsysCompleteAuthorize(optLogger) {
  var completeAuthorizeHandler = useCompleteAuthorizeHandler();
  return function (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt, clientSecret, headers, sdkAuthorization) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var iframeId = iframeIdOpt !== undefined ? iframeIdOpt : "redsys3ds";
    completeAuthorizeHandler(clientSecret, bodyArr, confirmParam, iframeId, optLogger, handleUserError, "Card", false, headers, undefined, sdkAuthorization);
  };
}

function usePaymentIntent(optLogger, paymentType) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  var paymentTypeFromUrl = CardThemeType$OrcaPaymentPage.getPaymentMode(componentName);
  var blockConfirm = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isConfirmBlocked);
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var isCallbackUsedVal = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  var setIsManualRetryEnabled = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  return function (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt, isThirdPartyFlowOpt, intentCallbackOpt, manualRetryOpt) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var iframeId = iframeIdOpt !== undefined ? iframeIdOpt : keys.iframeId;
    var isThirdPartyFlow = isThirdPartyFlowOpt !== undefined ? isThirdPartyFlowOpt : false;
    var intentCallback = intentCallbackOpt !== undefined ? intentCallbackOpt : (function (param) {
          
        });
    var manualRetry = manualRetryOpt !== undefined ? manualRetryOpt : false;
    var clientSecret = keys.clientSecret;
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
    }
    var paymentIntentID = Utils$OrcaPaymentPage.getPaymentId(clientSecret);
    var baseHeaders = [[
        "X-Client-Source",
        CardThemeType$OrcaPaymentPage.getPaymentModeToStrMapper(paymentTypeFromUrl)
      ]];
    var sdkAuth = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    if (sdkAuth !== undefined) {
      baseHeaders.push([
            "Authorization",
            sdkAuth
          ]);
    } else {
      baseHeaders.push([
            "api-key",
            confirmParam.publishableKey
          ]);
    }
    var returnUrlArr = [[
        "return_url",
        confirmParam.return_url
      ]];
    var manual_retry = manualRetry ? [[
          "retry_action",
          "manual_retry"
        ]] : [];
    var match = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    var clientSecretArr = match !== undefined ? [] : [[
          "client_secret",
          clientSecret
        ]];
    var body = clientSecretArr.concat(returnUrlArr, manual_retry);
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isThirdPartyFlow);
    var path = "payments/" + paymentIntentID + "/confirm";
    var uri = endpoint + "/" + path;
    var callIntent = function (body) {
      var contentLength = body.length.toString();
      var maskedPayload = JSON.stringify(maskPayload(Core__Option.getOr(Utils$OrcaPaymentPage.safeParseOpt(body), null)));
      JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                [
                  "payload",
                  maskedPayload
                ],
                [
                  "headers",
                  Utils$OrcaPaymentPage.getJsonFromArrayOfJson(baseHeaders.map(function (header) {
                            return [
                                    header[0],
                                    header[1]
                                  ];
                          }))
                ]
              ]));
      if (paymentType === "Card") {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", "CARD", undefined);
      } else {
        bodyArr.forEach(function (param) {
              if (param[0] === "payment_method_type") {
                LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", Utils$OrcaPaymentPage.getStringFromJson(param[1], ""), undefined);
              }
              
            });
      }
      if (blockConfirm && isIntegrationEnv) {
        console.warn("CONFIRM IS BLOCKED - Body", body);
        console.warn("CONFIRM IS BLOCKED - Headers", JSON.stringify(Object.fromEntries(baseHeaders)));
      } else {
        Core__Promise.$$catch(intentCall(Utils$OrcaPaymentPage.fetchApi, uri, baseHeaders, body, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "POST", setIsManualRetryEnabled, customPodUri, keys.sdkHandleOneClickConfirmPayment, 0, undefined, isCallbackUsedVal, componentName, redirectionFlags, Caml_option.some(keys.sdkAuthorization), undefined).then(function (val) {
                  intentCallback(val);
                  return Promise.resolve();
                }), (function (param) {
                return Promise.resolve();
              }));
      }
    };
    var intentWithoutMandate = function (mandatePaymentType) {
      var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo()), PaymentBody$OrcaPaymentPage.paymentTypeBody(mandatePaymentType))));
      callIntent(bodyStr);
    };
    if (typeof paymentMethodList !== "object") {
      if (paymentMethodList === "Loading") {
        return Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_loading", "Please wait. Try again!");
      } else {
        return intentWithoutMandate("");
      }
    }
    paymentMethodList.TAG === "Loaded";
    var paymentList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList._0));
    var mandatePaymentType = PaymentMethodsRecord$OrcaPaymentPage.paymentTypeToStringMapper(paymentList.payment_type);
    if (paymentList.payment_methods.length > 0) {
      var match$1 = paymentList.mandate_payment;
      if (match$1 === undefined) {
        return intentWithoutMandate(mandatePaymentType);
      }
      switch (paymentType) {
        case "BankTransfer" :
        case "Samsungpay" :
        case "Paze" :
        case "Other" :
            return intentWithoutMandate(mandatePaymentType);
        default:
          var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(PaymentBody$OrcaPaymentPage.mandateBody(mandatePaymentType), BrowserSpec$OrcaPaymentPage.broswerInfo()))));
          return callIntent(bodyStr);
      }
    } else {
      Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_empty", "Payment Failed. Try again!");
      console.warn("Please enable atleast one Payment method.");
      return ;
    }
  };
}

async function fetchSessions(clientSecret, publishableKey, walletsOpt, isDelayedSessionTokenOpt, logger, customPodUri, endpoint, isPaymentSessionOpt, merchantHostnameOpt, sdkAuthorizationOpt) {
  var wallets = walletsOpt !== undefined ? walletsOpt : [];
  var isDelayedSessionToken = isDelayedSessionTokenOpt !== undefined ? isDelayedSessionTokenOpt : false;
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var merchantHostname = merchantHostnameOpt !== undefined ? merchantHostnameOpt : Window$OrcaPaymentPage.getRootHostName();
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var headers = Object.fromEntries([[
          "X-Merchant-Domain",
          merchantHostname
        ]]);
  var paymentIntentID = Utils$OrcaPaymentPage.getPaymentId(clientSecret);
  var bodyArr = [
    [
      "payment_id",
      paymentIntentID
    ],
    [
      "wallets",
      wallets
    ],
    [
      "delayed_session_token",
      isDelayedSessionToken
    ]
  ];
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  var body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
                "client_secret",
                clientSecret
              ]]));
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        customBackendBaseUrl: endpoint,
        sdkAuthorization: sdkAuthorization
      }, "FetchSessions");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "SESSIONS_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Caml_option.some(customPodUri), Caml_option.some(publishableKey), isPaymentSession, undefined, Caml_option.some(sdkAuthorization), undefined);
}

async function confirmPayout(clientSecret, publishableKey, logger, customPodUri, endpoint, body, payoutId) {
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: publishableKey,
        customBackendBaseUrl: endpoint,
        clientSecret: clientSecret,
        payoutId: payoutId
      }, "ConfirmPayout");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  var body$1 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat([[
              "client_secret",
              clientSecret
            ]]));
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "CONFIRM_PAYOUT_CALL", logger, onSuccess, onFailure, JSON.stringify(body$1), undefined, "POST", Caml_option.some(customPodUri), Caml_option.some(publishableKey), undefined, undefined, undefined, undefined);
}

async function createPaymentMethod(clientSecret, publishableKey, logger, customPodUri, endpoint, body) {
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: publishableKey,
        customBackendBaseUrl: endpoint,
        clientSecret: clientSecret
      }, "CreatePaymentMethod");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  var body$1 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat([[
              "client_secret",
              clientSecret
            ]]));
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "CREATE_CUSTOMER_PAYMENT_METHODS_CALL", logger, onSuccess, onFailure, JSON.stringify(body$1), undefined, "POST", Caml_option.some(customPodUri), Caml_option.some(publishableKey), undefined, undefined, undefined, undefined);
}

async function fetchPaymentMethodList(sdkAuthorizationOpt, clientSecret, publishableKey, logger, customPodUri, endpoint) {
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        customBackendBaseUrl: endpoint,
        clientSecret: clientSecret,
        sdkAuthorization: sdkAuthorization
      }, "FetchPaymentMethodList");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "PAYMENT_METHODS_CALL", logger, onSuccess, onFailure, undefined, undefined, "GET", Caml_option.some(customPodUri), Caml_option.some(publishableKey), undefined, undefined, Caml_option.some(sdkAuthorization), undefined);
}

async function fetchCustomerPaymentMethodList(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, sdkAuthorizationOpt) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        customBackendBaseUrl: endpoint,
        clientSecret: clientSecret,
        sdkAuthorization: sdkAuthorization
      }, "FetchCustomerPaymentMethodList");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "CUSTOMER_PAYMENT_METHODS_CALL", logger, onSuccess, onFailure, undefined, undefined, "GET", Caml_option.some(customPodUri), Caml_option.some(publishableKey), isPaymentSession, undefined, Caml_option.some(sdkAuthorization), undefined);
}

function paymentIntentForPaymentSession(body, paymentType, payload, publishableKey, clientSecret, logger, customPodUri, redirectionFlags, isPaymentSessionOpt, sdkAuthorizationOpt, modeOpt) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : true;
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var mode = modeOpt !== undefined ? modeOpt : "NONE";
  var confirmParams = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(payload), "confirmParams");
  var redirect = Utils$OrcaPaymentPage.getString(confirmParams, "redirect", "if_required");
  var returnUrl = Utils$OrcaPaymentPage.getString(confirmParams, "return_url", "");
  var confirmParam_redirect = redirect;
  var confirmParam = {
    return_url: returnUrl,
    publishableKey: publishableKey,
    redirect: confirmParam_redirect
  };
  var paymentIntentID = Core__Option.getOr(clientSecret.split("_secret_")[0], "");
  var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKey, true);
  var uri = endpoint + "/payments/" + paymentIntentID + "/confirm";
  var sdkAuth = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  var headers = sdkAuth !== undefined ? [[
        "Authorization",
        sdkAuth
      ]] : [[
        "api-key",
        publishableKey
      ]];
  var broswerInfo = BrowserSpec$OrcaPaymentPage.broswerInfo();
  var returnUrlArr = [[
      "return_url",
      returnUrl
    ]];
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  var clientSecretArr = match !== undefined ? [] : [[
        "client_secret",
        clientSecret
      ]];
  var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(broswerInfo, clientSecretArr, returnUrlArr)));
  return intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, bodyStr, confirmParam, clientSecret, logger, false, paymentType, "", "POST", (function (param) {
                
              }), customPodUri, false, 0, isPaymentSession, undefined, undefined, redirectionFlags, Caml_option.some(sdkAuthorization), mode);
}

async function callAuthLink(publishableKey, clientSecret, paymentMethodType, pmAuthConnectorsArr, iframeId, logger, sdkAuthorizationOpt) {
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: publishableKey,
        sdkAuthorization: sdkAuthorization
      }, "CallAuthLink");
  var bodyArr = [
    [
      "payment_id",
      Utils$OrcaPaymentPage.getPaymentId(Core__Option.getOr(clientSecret, ""))
    ],
    [
      "payment_method",
      "bank_debit"
    ],
    [
      "payment_method_type",
      paymentMethodType
    ]
  ];
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  var body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
                "client_secret",
                Core__Option.getOr(clientSecret, "")
              ]]));
  var onSuccess = function (data) {
    var metaData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
          [
            "linkToken",
            Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(data), "link_token", "")
          ],
          [
            "pmAuthConnectorArray",
            pmAuthConnectorsArr
          ],
          [
            "publishableKey",
            publishableKey
          ],
          [
            "sdkAuthorization",
            Core__Option.getOr(sdkAuthorization, "")
          ],
          [
            "clientSecret",
            Core__Option.getOr(clientSecret, "")
          ],
          [
            "isForceSync",
            false
          ]
        ]);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "fullscreen",
            true
          ],
          [
            "param",
            "plaidSDK"
          ],
          [
            "iframeId",
            iframeId
          ],
          [
            "metadata",
            metaData
          ]
        ]);
    return null;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "PAYMENT_METHODS_AUTH_LINK_CALL", logger, onSuccess, onFailure, JSON.stringify(body), undefined, "POST", undefined, Caml_option.some(publishableKey), undefined, undefined, Caml_option.some(sdkAuthorization), undefined);
}

async function callAuthExchange(publicToken, clientSecret, paymentMethodType, publishableKey, setOptionValue, logger, sdkAuthorizationOpt) {
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: publishableKey,
        sdkAuthorization: sdkAuthorization
      }, "CallAuthExchange");
  var bodyArr = [
    [
      "payment_id",
      Utils$OrcaPaymentPage.getPaymentId(Core__Option.getOr(clientSecret, ""))
    ],
    [
      "payment_method",
      "bank_debit"
    ],
    [
      "payment_method_type",
      paymentMethodType
    ],
    [
      "public_token",
      publicToken
    ]
  ];
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  var body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
                "client_secret",
                Core__Option.getOr(clientSecret, "")
              ]]));
  var onSuccess = function (param) {
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
    Core__Promise.$$catch(fetchCustomerPaymentMethodList(Core__Option.getOr(clientSecret, ""), publishableKey, logger, "", endpoint, undefined, Caml_option.some(sdkAuthorization)).then(function (customerListResponse) {
              var customerListResponse$1 = Object.fromEntries([[
                      "customerPaymentMethods",
                      customerListResponse
                    ]]);
              setOptionValue(function (prev) {
                    var newrecord = Caml_obj.obj_dup(prev);
                    newrecord.customerPaymentMethods = PaymentType$OrcaPaymentPage.createCustomerObjArr(customerListResponse$1, "customerPaymentMethods");
                    return newrecord;
                  });
              return Promise.resolve(null);
            }), (function (e) {
            console.error("Unable to retrieve customer/payment_methods after auth/exchange because of ", e);
            return Promise.resolve(null);
          }));
    return null;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "PAYMENT_METHODS_AUTH_EXCHANGE_CALL", logger, onSuccess, onFailure, JSON.stringify(body), undefined, "POST", undefined, Caml_option.some(publishableKey), undefined, undefined, Caml_option.some(sdkAuthorization), undefined);
}

async function calculateTax(apiKey, clientSecret, paymentMethodType, shippingAddress, logger, customPodUri, sessionId, sdkAuthorization) {
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        publishableKey: apiKey,
        clientSecret: clientSecret,
        sdkAuthorization: sdkAuthorization
      }, "CalculateTax");
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  var body = [
    [
      "shipping",
      shippingAddress
    ],
    [
      "payment_method_type",
      paymentMethodType
    ]
  ];
  var match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  if (match !== undefined) {
    
  } else {
    body.push([
          "client_secret",
          clientSecret
        ]);
  }
  Core__Option.mapOr(sessionId, undefined, (function (id) {
          body.push([
                "session_id",
                id
              ]);
        }));
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "EXTERNAL_TAX_CALCULATION", logger, onSuccess, onFailure, JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body)), undefined, "POST", Caml_option.some(customPodUri), Caml_option.some(apiKey), undefined, undefined, Caml_option.some(sdkAuthorization), undefined);
}

function usePostSessionTokens(optLogger, paymentType, paymentMethod) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var paymentTypeFromUrl = CardThemeType$OrcaPaymentPage.getPaymentMode(CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName"));
  var customPodUri = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var paymentMethodList = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var keys = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var redirectionFlags = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  var setIsManualRetryEnabled = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  return function (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt, isThirdPartyFlowOpt, intentCallbackOpt, $staropt$star) {
    var handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    var iframeId = iframeIdOpt !== undefined ? iframeIdOpt : keys.iframeId;
    var isThirdPartyFlow = isThirdPartyFlowOpt !== undefined ? isThirdPartyFlowOpt : false;
    var intentCallback = intentCallbackOpt !== undefined ? intentCallbackOpt : (function (param) {
          
        });
    if ($staropt$star === undefined) {
      false;
    }
    var clientSecret = keys.clientSecret;
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("post_session_tokens_failed", "Post Session Tokens failed. Try again!");
    }
    var paymentIntentID = Utils$OrcaPaymentPage.getPaymentId(clientSecret);
    var headers = [
      [
        "Content-Type",
        "application/json"
      ],
      [
        "X-Client-Source",
        CardThemeType$OrcaPaymentPage.getPaymentModeToStrMapper(paymentTypeFromUrl)
      ]
    ];
    var body = [
      [
        "payment_id",
        paymentIntentID
      ],
      [
        "payment_method_type",
        paymentType
      ],
      [
        "payment_method",
        paymentMethod
      ]
    ];
    var sdkAuth = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    if (sdkAuth !== undefined) {
      headers.push([
            "Authorization",
            sdkAuth
          ]);
    } else {
      headers.push([
            "api-key",
            confirmParam.publishableKey
          ]);
      body.push([
            "client_secret",
            clientSecret
          ]);
    }
    var endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isThirdPartyFlow);
    var uri = endpoint + "/payments/" + paymentIntentID + "/post_session_tokens";
    var callIntent = function (body) {
      var contentLength = body.length.toString();
      var maskedPayload = JSON.stringify(maskPayload(Core__Option.getOr(Utils$OrcaPaymentPage.safeParseOpt(body), null)));
      JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                [
                  "payload",
                  maskedPayload
                ],
                [
                  "headers",
                  Utils$OrcaPaymentPage.getJsonFromArrayOfJson(headers.map(function (header) {
                            return [
                                    header[0],
                                    header[1]
                                  ];
                          }))
                ]
              ]));
      if (paymentType === "Card") {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", "CARD", undefined);
      } else {
        bodyArr.forEach(function (param) {
              if (param[0] === "payment_method_type") {
                LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", Utils$OrcaPaymentPage.getStringFromJson(param[1], ""), undefined);
              }
              
            });
      }
      Core__Promise.$$catch(intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, body, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "POST", setIsManualRetryEnabled, customPodUri, keys.sdkHandleOneClickConfirmPayment, 0, undefined, undefined, undefined, redirectionFlags, Caml_option.some(keys.sdkAuthorization), undefined).then(function (val) {
                intentCallback(val);
                return Promise.resolve();
              }), (function (param) {
              return Promise.resolve();
            }));
    };
    var intentWithoutMandate = function (mandatePaymentType) {
      var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo()), PaymentBody$OrcaPaymentPage.paymentTypeBody(mandatePaymentType))));
      callIntent(bodyStr);
    };
    if (typeof paymentMethodList !== "object") {
      if (paymentMethodList === "Loading") {
        return Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_loading", "Please wait. Try again!");
      } else {
        return intentWithoutMandate("");
      }
    }
    paymentMethodList.TAG === "Loaded";
    var paymentList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList._0));
    var mandatePaymentType = PaymentMethodsRecord$OrcaPaymentPage.paymentTypeToStringMapper(paymentList.payment_type);
    if (paymentList.payment_methods.length > 0) {
      var match = paymentList.mandate_payment;
      if (match === undefined) {
        return intentWithoutMandate(mandatePaymentType);
      }
      switch (paymentType) {
        case "BankTransfer" :
        case "Samsungpay" :
        case "Paze" :
        case "Other" :
            return intentWithoutMandate(mandatePaymentType);
        default:
          var bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(PaymentBody$OrcaPaymentPage.mandateBody(mandatePaymentType), BrowserSpec$OrcaPaymentPage.broswerInfo()))));
          return callIntent(bodyStr);
      }
    } else {
      Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_empty", "Payment Failed. Try again!");
      console.warn("Please enable atleast one Payment method.");
      return ;
    }
  };
}

async function fetchEnabledAuthnMethodsToken(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, profileId, authenticationId) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        customBackendBaseUrl: endpoint,
        authenticationId: authenticationId
      }, "FetchEnabledAuthnMethodsToken");
  var body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "client_secret",
          clientSecret
        ]]);
  var headers = Object.fromEntries([[
          "x-profile-id",
          profileId
        ]]);
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "ENABLED_AUTHN_METHODS_TOKEN_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Caml_option.some(customPodUri), Caml_option.some(publishableKey), isPaymentSession, undefined, undefined, undefined);
}

async function fetchEligibilityCheck(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, profileId, authenticationId, bodyArr) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        customBackendBaseUrl: endpoint,
        authenticationId: authenticationId
      }, "FetchEligibilityCheck");
  var body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
              "client_secret",
              clientSecret
            ]]));
  var headers = Object.fromEntries([[
          "x-profile-id",
          profileId
        ]]);
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (param) {
    return null;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "ELIGIBILITY_CHECK_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Caml_option.some(customPodUri), Caml_option.some(publishableKey), isPaymentSession, undefined, undefined, undefined);
}

async function fetchAuthenticationSync(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, profileId, authenticationId, merchantId, bodyArr) {
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
        customBackendBaseUrl: endpoint,
        authenticationId: authenticationId,
        merchantId: merchantId
      }, "FetchAuthenticationSync");
  var body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
              "client_secret",
              clientSecret
            ]]));
  var headers = Object.fromEntries([[
          "x-profile-id",
          profileId
        ]]);
  var onSuccess = function (data) {
    return data;
  };
  var onFailure = function (err) {
    return err;
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "AUTHENTICATION_SYNC_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Caml_option.some(customPodUri), Caml_option.some(publishableKey), isPaymentSession, undefined, undefined, undefined);
}

function getConstructedPaymentMethodName(paymentMethod, paymentMethodType) {
  switch (paymentMethod) {
    case "bank_debit" :
        return paymentMethodType + "_debit";
    case "bank_transfer" :
        if (Constants$OrcaPaymentPage.bankTransferList.includes(paymentMethodType)) {
          return paymentMethodType;
        } else {
          return paymentMethodType + "_transfer";
        }
    case "card" :
        return "card";
    default:
      return paymentMethodType;
  }
}

export {
  getPaymentType ,
  closePaymentLoaderIfAny ,
  retrievePaymentIntent ,
  fetchPaymentMethodEligibility ,
  threeDsAuth ,
  pollRetrievePaymentIntent ,
  retrieveStatus ,
  pollStatus ,
  intentCall ,
  usePaymentSync ,
  maskStr ,
  maskPayload ,
  useCompleteAuthorizeHandler ,
  useCompleteAuthorize ,
  useRedsysCompleteAuthorize ,
  usePaymentIntent ,
  fetchSessions ,
  confirmPayout ,
  createPaymentMethod ,
  fetchPaymentMethodList ,
  fetchCustomerPaymentMethodList ,
  paymentIntentForPaymentSession ,
  callAuthLink ,
  callAuthExchange ,
  calculateTax ,
  usePostSessionTokens ,
  fetchEnabledAuthnMethodsToken ,
  fetchEligibilityCheck ,
  fetchAuthenticationSync ,
  getConstructedPaymentMethodName ,
}
/* recoil Not a pure module */
